module.exports = __webpack_public_path__ + "static/media/login-koobits-logo.97c7527b.svg";